export default __webpack_public_path__ + "static/media/FINAL_LOGO.75ae834d.png";